export default "__VITE_ASSET__V0Z7GmHL__"